import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bijlagen',
  templateUrl: './bijlagen.component.html',
  styleUrls: ['./bijlagen.component.css']
})
export class BijlagenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
